import { useEffect } from 'react'
import type { SidebarContextType } from '../components/layout/DashboardLayout'

/**
 * DT-3: a full-bleed page (the analytics map) collapses the dashboard sidebar for real
 * estate on entry, then RESTORES whatever the sidebar state was before, on exit.
 * Snapshots the mount-time `collapsed` value and replays it on unmount.
 */
export function useSidebarAutoCollapse(sidebar: SidebarContextType | undefined) {
  useEffect(() => {
    const prev = sidebar?.collapsed ?? false
    sidebar?.setCollapsed(true)
    return () => sidebar?.setCollapsed(prev)
    // Mount/unmount only — snapshot the entry-time state deliberately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
